var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooksAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 89,
    viewBox: "0 0 85 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0871 76.1667H9.04167V17.25H0.625V76.1667C0.625 78.3989 1.51175 80.5397 3.09018 82.1182C4.66861 83.6966 6.80943 84.5833 9.04167 84.5833H46.1171C44.5694 82.0015 43.5402 79.1426 43.0871 76.1667ZM67.9583 0.416668H46.9167V21.4583L38.5 15.1458L30.0833 21.4583V0.416668H25.875C23.6428 0.416668 21.5019 1.30342 19.9235 2.88185C18.3451 4.46028 17.4583 6.6011 17.4583 8.83333V59.3333C17.4583 61.5656 18.3451 63.7064 19.9235 65.2848C21.5019 66.8632 23.6428 67.75 25.875 67.75H43.0871C43.6999 64.1209 45.0987 60.6696 47.1856 57.6378C49.2724 54.6061 51.9968 52.0672 55.1679 50.199C58.339 48.3308 61.8803 47.1785 65.5435 46.8226C69.2068 46.4668 72.9036 46.9162 76.375 48.1392V8.83333C76.375 6.6011 75.4882 4.46028 73.9098 2.88185C72.3314 1.30342 70.1906 0.416668 67.9583 0.416668ZM72.1667 55.125V67.75H84.7917V76.1667H72.1667V88.7917H63.75V76.1667H51.125V67.75H63.75V55.125H72.1667Z",
    fill: "#FF731D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksAdd);
export default __webpack_public_path__ + "static/media/books-add.ea8dcf98c94a8a1e389e658d39a76d0b.svg";
export { ForwardRef as ReactComponent };